import {View} from '@gongxigames/framework/slot/fragments/module/view/View';

export enum LayoutTypes {
    LANDSCAPE,
    PORTRAIT
}

// TODO: remove
export abstract class ViewMobile extends View {
    protected _views: View[] = [];

    public on(id: string | symbol, callback: Function, owner: Object, priority = 0, data: any = null): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.on(id, callback, priority, data));
        } else {
            super.on(id, callback, priority, data);
        }
    }

    public off(id: string | symbol, owner: Object): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.off(id, owner));
        } else {
            super.off(id, owner);
        }
    }

    public emit(id: string | symbol, ...args: any[]): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.emit(id, args));
        } else {
            super.emit(id, args);
        }
    }

    public show(): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.show());
        } else {
            super.show();
        }
    }

    public hide(): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.hide());
        } else {
            super.hide();
        }
    }

    public onResourcesLoaded(): void {
        if (this._views.length > 0) {
            this._views.forEach(view => view.onResourcesLoaded());
        } else {
            super.onResourcesLoaded();
        }
    }

    public onLandscape(): void {
        this._views[LayoutTypes.PORTRAIT].hide();
        this._views[LayoutTypes.LANDSCAPE].show();
    }

    public onPortrait(): void {
        this._views[LayoutTypes.PORTRAIT].show();
        this._views[LayoutTypes.LANDSCAPE].hide();
    }
}
